import type { PreparedAuctionItem } from '@autobid/ui/types/components/AuctionsData'
import { useAuctionPagesLink } from './useAuctionPagesLink'

type UseAuctionLinkParams = Pick<
  PreparedAuctionItem,
  'slug' | 'appId' | 'stage' | 'startDate' | 'type'
>

/**
 * Get auction link basing on a stage
 */
export function useAuctionLink({
  appId,
  slug,
  stage,
  startDate,
  type,
}: UseAuctionLinkParams) {
  const nowTimestamp = new Date().getTime()
  const startDateTimestamp = new Date(startDate).getTime()
  const page
    = stage === 'ONLINE' && nowTimestamp >= startDateTimestamp
      ? 'current'
      : 'car-list'
  const { getLink } = useAuctionPagesLink(appId)

  return computed(() => {
    if (stage === 'IN_PREPARATION' || type === 'LIVE' || !slug) {
      return undefined
    }

    return getLink({ page, slug })
  })
}
